const React = require('react');

const ExpressMobileContext = React.createContext();
const useReviewMobileContext = () => React.useContext(ExpressMobileContext);

module.exports = { ExpressMobileContext, useReviewMobileContext };